import React from 'react';
import { useTranslation } from 'react-i18next';
import PieChart from '../../../charts/PieChart'
import { Loader } from '../../../components';
import versionCompare from '../../../../services/versionCompare';
import { useGetAppAdminSdkVersionPerOsQuery } from '../../../../api/appAdminApiSlice';
import Block from '../../../Block';

const DevicePerSdkVersion = ({appId, ...props}) => {
  const { t } = useTranslation();
  const { data = [], isSuccess, isError, refetch } = useGetAppAdminSdkVersionPerOsQuery(appId)
  const loaderProps = { success: isSuccess, error: isError, retry: refetch }
  const pieData = [...data].sort((a,b) => versionCompare(b.sdk_version,a.sdk_version) )
                      .map((x)=>({"name":x.sdk_version,"y":x.active_devices}))

  return (
    <Block title={t('version.device_per_sdk_version')} {...props}>
      <Loader {...loaderProps} minHeight={"100%"}>
        <PieChart data={pieData} legendOptions={{show: false}} datalabels/>
      </Loader>
    </Block>
  )
}

export default DevicePerSdkVersion
